<template>
  <div class="offline line">
    <div class="toolsb">
      <el-select v-model="assesmentId" placeholder="考核" v-on:change="mFilterTableData(assesmentId)" style="margin-right:20px;">
        <el-option v-for="item in tableList" :key="item.assesmentId" :label="item.assesmentName" :value="item.assesmentId">
        </el-option>
      </el-select>
      <el-select v-model="classerId" placeholder="班级" v-on:change="mClassTableData(classerId)">
        <el-option v-for="item in classList" :key="item.classerId" :label="item.classerName" :value="item.classerId">
        </el-option>
      </el-select>
      <div class="rightLine">
        <a @click="gitDocs" download>
          <el-button style="margin-left: 10px">Excel模板下载</el-button>
        </a>
        <el-button style="margin-left: 10px" @click="dialogFormVisible=true">线下成绩导入</el-button>
        <el-button style="margin-left: 10px" type="danger" @click="handleDeleteBatch">批量删除</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="assesmentRecordId" label="编号" align="center" width="55"></el-table-column>
      <el-table-column prop="assesmentName" label="考核名称" align="center"></el-table-column>
      <el-table-column prop="nickName" label="学员名称" align="center"></el-table-column>
      <el-table-column label="成绩" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isPass == 1" class="adopt">通过</span>
          <span v-if="scope.row.isPass == 0" class="Fail">未通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="classerName" label="班级" align="center"></el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    <!-- Excel文件导入 -->
    <el-dialog title="Excel批量导入" :visible.sync="dialogFormVisible" width="564px">
      <span style="margin-left:120px;">考核名称</span>
      <el-select v-model="uploadData.assesmentId" placeholder="请选择考核名称" label="考核名称" style="width:229px;height:40px;margin-left:20px;">
        <el-option v-for="(item,index) in tableList" :label="item.assesmentName" :key="index" :value="item.assesmentId"></el-option>
      </el-select>
      <el-upload class="upload-demo" drag :limit="1" :action="upAction" :data="uploadData" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" :headers="uploadHeader" :on-success="uploadSuccess" :before-upload="beforeUpload" style="margin:20px 0 30px 87px;">
        <i class=" el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <el-button @click="handleCancel" style="margin-left:340px">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </el-dialog>
    <!-- 编辑页面 -->
    <el-dialog title="编辑" :visible.sync="showFlag" width="474px">
      <span style="margin: 0 40px 0 60px">成绩</span>
      <el-select v-model="isPass" placeholder="通过" label="成绩" style="width:229px;height:40px;">
        <el-option v-for="(item,index) in achievement" :label="item.name" :key="index" :value="item.value"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showFlag = false">取 消</el-button>
        <el-button type="primary" @click="queryachievement">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import CommonStyle from "@/utils/CommonStyle";
import Auth from "@/utils/Auth";

export default {
  data () {
    return {
      upAction: "", // 文件地址
      uploadHeader: { // 文件头部
        Authorization: "",
      },
      tableData: [],  // 表格数据
      classerId: "",  // 班级id
      assesmentId: "",
      classList: [], // 班级列表数据
      tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle, // 表头格式
      curPage: 1, // 分页
      total: 0, //总条数
      dialogFormVisible: false, // 显示/隐藏Excel文件导入
      uploadData: {
        assesmentId: null
      },
      tableList: [], // 提交的课程名称id数组 
      file: {}, // 上传的文件
      showFlag: false,  // 显示/隐藏
      isPass: 1,  // 是否通过
      assesmentRecordId: '', // 课程id
      multipleSelection: [], // 批量删除的数组 
      achievement: [{
        name: "通过",
        value: 1,
      }, {
        name: "未通过",
        value: 0,
      }]
    }
  },
  mounted () {
    this.upAction = process.env.VUE_APP_PREFIX + "/learn/record/importOfflineRecord";
    this.uploadHeader.Authorization = Auth.getToken();
    this.recordList(this, 1);
    this.assesmentList();
    this.classerList(this);
  },
  methods: {
    // 获取表格数据
    recordList (that, curPage) {
      that.HttpConnection.get("/learn/record/listRecord", {
        params: {
          assesmentId: that.assesmentId,
          classerId: that.classerId,
          pageNum: curPage,
          pageSize: 10
        }
      }).then(function (response) {
        that.tableData = response.rows;
        that.total = response.total;
      });
    },
    // 获取班级id
    mFilterTableData (assesmentId) {
      this.assesmentId = assesmentId;
      this.recordList(this, 1, 10);
    },
    mClassTableData (classerId) {
      this.classerId = classerId;
      this.recordList(this, 1, 10);
    },
    // 获取班级列表
    classerList (that) { // 班级列表
      that.HttpConnection.get("/teach/classer/teacherlist").then(function (response) {
        that.classList = response.rows;
      });
    },
    // 将选中的数据存放进数组
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 批量删除
    handleDelete (index, row) {
      let that = this;
      this.$confirm("确定要删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        that.HttpConnection.delete("/learn/record/remove/" + row.assesmentRecordId, {
          params: {}
        }).then(function (response) {
          that.$message({
            type: "success",
            message: "删除成功!"
          });
          that.recordList(that, that.curPage);
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      })
    },
    // 下载模板
    gitDocs () {
      // let that = this;
      // that.HttpConnection.get("/learn/record/downloadTemplate", {
      // }).then((res) => {
      //   window.open(process.env.VUE_APP_imagePath + res.data)
      //   // that.HttpConnection.delete("/fastdfs/delete/file", {
      //   //   params: {
      //   //     locale: 0,
      //   //     filePath: res.data,
      //   //   }
      //   // })
      //   console.log(1);
      // }).catch((err) => {
      //   console.log(err);
      // })
      let a = document.createElement("a"); //创建一个<a></ a>标签
        a.href = "static/offlineRecordTemp.xlsx"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加点.
        a.download = "学员成绩模板.xlsx"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.pdfd即可
        a.style.display = "none"; // 障眼法藏起来a标签
        document.body.appendChild(a); // 将a标签追加到文档对象中
        a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove(); // 一次性的，用完就删除a标签
    },
    handleDeleteBatch () {
      let that = this;
      console.log(that.multipleSelection);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = that.multipleSelection.map(function (item) {
          return item.assesmentRecordId;
        });
        that.HttpConnection.delete("/learn/record/batchRemove/" + ids, {
          params: {}
        }).then(function (response) {
          that.$message({
            type: "success",
            message: "删除成功!"
          });
          that.recordList(that, that.curPage);
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    // 编辑
    handleEdit (index, row) {
      console.log(this.isPass, row);
      this.showFlag = true;
      this.assesmentRecordId = row.assesmentRecordId
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.$store.commit("setCurPage", val);
      this.recordList(this, val);
    },
    // 取消提交
    handleCancel () {
      this.dialogFormVisible = false;
    },
    // 确定提交
    handleSubmit () {
      let that = this
      this.dialogFormVisible = false;
      this.recordList(that, 1)
    },
    // 获取提交的课程名称id
    assesmentList () { // 考核列表
      let that = this;
      that.HttpConnection.get("/learn/assesment/list", {
        params: {
          pageNum: 1,
          pageSize: 10
        }
      }).then(function (response) {
        that.tableList = response.rows;
      });
    },
    beforeUpload (file) {
      if (this.uploadData.assesmentId == null) {
        this.$message.error("请先选择考核");
      }
    },
    // 导入文件
    uploadSuccess (res, file) {
      let that = this;
      // console.log(file, res);
      if (res.code === 200) {
        that.$message({
          type: "info",
          message: "导入成功",
        });
      } else {
        that.$message.error(res.msg);
      }
    },
    // 编辑提交
    queryachievement () {
      this.showFlag = false;
      let that = this;
      that.HttpConnection.put("/learn/record//edit", {
        assesmentRecordId: that.assesmentRecordId,
        isPass: that.isPass
      }).then((res) => {
        that.$message({
          type: "success",
          message: "编辑成功"
        });
        that.dialogVisible = false;
        that.recordList(that, that.curPage);
      }).catch((err) => {
        console.log(err);
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rightLine {
  margin-left: 165px;
}
.line {
  margin: 20px 0;
}
a {
  color: #606266;
}
</style>